import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EncryptionService } from './encryption.service';
import { tap } from 'rxjs/operators';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private encryptionService: EncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const pTokenData = this.encryptionService.getDataFromLocalStorage('NPToken');
    const token = JSON.parse(pTokenData); // Get the token from local storage (or another secure place)
    // If the token exists, clone the request and add the authorization header
    if (token) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token)
      });
      return next.handle(cloned);
    } else {
        // If no token, proceed with the original request
        return next.handle(req).pipe(
          tap(
            (event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                // Handle the response and capture the status code
                // console.log('Status code:', event.status);
              }
            },
            (error: any) => {
              // Handle the error and capture the status code
              if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                 localStorage.clear();
                }
              }
            }
          )
        );
      }
  }
}
